import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";

export class RunCommandCreationCommand {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly frontend
  ) { }

  async run(params?): Promise<any> {
    let args = {}
    if (params) {
      args = {
        args:params
      }
    }
    try {
      if (params) {
        this.frontend.run_command_generic_loading = true
      } else {
        this.frontend.run_command_loading = true
      }
      await this.dispatcher.dispatch('create.run.command', args)
      if (params)
        this.frontend.args_run_command = ''
    } catch (error) {
      console.log('Error while create run command', error)
    }
    if (params) {
      this.frontend.run_command_generic_loading = false
    } else {
      this.frontend.run_command_loading = false
    }
  }
}